const getAskFieldByKey = (key: string, storageKey = 'inquiryData') => {
  var jsonString = localStorage.getItem(storageKey);

  if (!jsonString) {
    return null;
  }

  var jsonData = JSON.parse(jsonString);

  if (jsonData) {
    return jsonData[key];
  } else {
    return null;
  }
}

export const getInquiryUserData = () => {
  const country = 'TW';
  const postcode = '24162';

  return {
    phone_number: getAskFieldByKey('mobile'),
    first_name: getAskFieldByKey('name'),
    last_name: getAskFieldByKey('name'),
    city: getAskFieldByKey('region'),
    country: country,
    postal_code: postcode,
  }
}

// ADS再营销跟踪-我要詢價
export const sendInquiryAdsRemarketing = () => {
  window.gtag("event", "inquiry_success", {
    send_to: "AW-1033257263",
    value: 1,
  });
}

// ADS再营销跟踪-業代優惠
export const sendAgentAdsRemarketing = () => {
  window.gtag("event", "conversion", {
    send_to: "AW-1033257263/XsoeCIyEgdoCEK-C2ewD"
  });
}

// ADS再营销跟踪-業代提交資料
export const sendAgentSubmitAdsRemarketing = () => {
  window.gtag("event", "conversion", {
    send_to: "AW-1033257263/f4WICI_X3IMYEK-C2ewD"
  });
}

// 增强型转化跟踪
export const sendInquiryAds = () => {
  const { phone_number, first_name, last_name, city, country, postal_code } = getInquiryUserData();

  window.gtag("set", "user_data", {
    email: "",
    phone_number,
    address: {
      first_name,
      last_name,
      city,
      country,
      postal_code
    }
  });

  window.gtag("event", "conversion", {
    send_to: "AW-1033257263/r-3zCLWCtd0BEK-C2ewD",
  });
}